// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","fill":"Loader_fill__ZNGuA","loaderWrapper":"Loader_loaderWrapper__XU8WQ"};